import {faro, LogLevel} from '@grafana/faro-web-sdk';

import type {ObservabilityProvider} from './observability';
import logger from './logger';


export class FaroObservabilityProvider implements ObservabilityProvider {
  error(error: Error, context?: Record<string, string>): void {
    try {
      faro.api?.pushError(error, {context});
    } catch (error) {
      logger.error('error in FaroObservabilityProvider.error', error);
    }
  }
  /**
   * Faro dedupes identical log payloads by default. We disable that so each
   * emission is kept (e.g. same message with different context, or tight loops).
   * skipDedupe: true skips deduplication.
   */
  warn(message: string, context?: Record<string, string>): void {
    try {
      faro.api?.pushLog([message], {
        level: LogLevel.WARN,
        context,
        skipDedupe: true,
      });
    } catch (error) {
      logger.error('error in FaroObservabilityProvider.warn', error);
    }
  }

  log(message: string, context?: Record<string, string>): void {
    try {
      faro.api?.pushLog([message], {
        level: LogLevel.INFO,
        context,
        skipDedupe: true,
      });
    } catch (error) {
      logger.error('error in FaroObservabilityProvider.log', error);
    }
  }
}
